import { useEffect } from 'react';
import { connect } from "react-redux";

function ConnectedTriggerWrapper({storeAuth, freemiumTracksLoad}) {
  useEffect(() => {
    freemiumTracksLoad === 3 && storeAuth.link();
  }, [freemiumTracksLoad, storeAuth])
  return null;
}

const TriggerWrapper = connect(
  state => ({
    freemiumTracksLoad: state.freemiumTracksLoad,
    storeAuth: state.storeAuth
  })
)(ConnectedTriggerWrapper);

export default TriggerWrapper;
